import { useCallback, useEffect, useState, } from "react";
import { assets } from "../../assets/assets";
import DropDownList from "../../components/forms/DropDownList/DropDownList";
import Toggle from "../../components/forms/Toggle/Toggle";
import ToggleCheck from "../../components/forms/ToggleCheck/ToggleCheck";
import NavLink from "../.."
import { ACCOUNT_TYPES, getAcTypeData } from "../../helpers/AccountTypes";
import { IconJsxer } from "../../helpers/IconHelper";
import { getShortDateString } from "../../helpers/Dates";

const ListedBugReport = (props) => {
    const { bugReport, priorities, statuses, developers, changePriorityFunc, changeStatusFunc, setBugReportToEdit, prepareEditData } = props;

    const getItemIndex = useCallback((items, idToMatch) => {
      if (!Array.isArray(items) || items.length === 0) {
        return 0;
      }

      const target = normaliseText(idToMatch);
      const matched = items.find((it) => {
        const idText = normaliseText(it?.id);
        const labelText = normaliseText(it?.label);

        if (idText === target || labelText === target) {
          return true;
        }

        // Handle legacy status labels such as "Issues Found (Staging)" stored in data.
        if (target.includes("issues found") && idText === "on hold") {
          return true;
        }
        if (target.includes("ready for qa") && idText === "ready for qa") {
          return true;
        }
        if (target.includes("twitch review") && idText === "twitch review") {
          return true;
        }
        if (target === "done" && idText === "complete") {
          return true;
        }

        return false;
      });
      if (!matched) {
        return 0;
      }

      if (typeof matched.index === "number") {
        return matched.index;
      }

      const fallbackIndex = items.findIndex((it) => it?.id === idToMatch);
      return fallbackIndex >= 0 ? fallbackIndex : 0;
    }, []);

    const normaliseText = (val) => String(val || "")
      .toLowerCase()
      .replace(/[_-]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();

    const getPriorityClass = useCallback((priorityItem) => {
      const key = normaliseText(priorityItem?.id || priorityItem?.label || priorityItem);
      switch (key) {
        case "high":
          return "high-priority-colour";
        case "medium":
          return "medium-priority-colour";
        case "low":
          return "low-priority-colour";
        case "wishlist":
          return "wishlist-priority-colour";
        default:
          return "";
      }
    }, []);

    const getStatusClass = useCallback((statusItem) => {
      const key = normaliseText(statusItem?.id || statusItem?.label || statusItem);
      switch (key) {
        case "new":
        case "to do":
          return "new-status-colour";
        case "in progress":
          return "inprogress-status-colour";
        case "on hold":
        case "issues found (staging)":
        case "issues found":
          return "onhold-status-colour";
        case "ready for qa":
        case "ready for qa (staging)":
          return "ready-for-qa-status-colour";
        case "twitch review":
        case "twitch review (staging)":
        case "ready for twitch review":
          return "ready-for-twitch-review-status-colour";
        case "promote to production":
          return "promote-to-production-status-colour";
        case "ignored":
          return "ignored-status-colour";
        case "complete":
        case "completed":
          return "complete-status-colour";
        default:
          return "";
      }
    }, []);

    const getStatusOptionClass = useCallback((statusItem) => {
      const key = normaliseText(statusItem?.id || statusItem?.label || statusItem);
      switch (key) {
        case "new":
        case "to do":
          return "bug-select-option bug-status-option-new";
        case "in progress":
          return "bug-select-option bug-status-option-inprogress";
        case "on hold":
        case "issues found (staging)":
        case "issues found":
          return "bug-select-option bug-status-option-onhold";
        case "ready for qa":
        case "ready for qa (staging)":
          return "bug-select-option bug-status-option-readyqa";
        case "twitch review":
        case "twitch review (staging)":
        case "ready for twitch review":
          return "bug-select-option bug-status-option-twitchreview";
        case "promote to production":
          return "bug-select-option bug-status-option-promote";
        case "ignored":
          return "bug-select-option bug-status-option-ignored";
        case "complete":
        case "completed":
        case "done":
          return "bug-select-option bug-status-option-complete";
        default:
          return "";
      }
    }, []);

    const getPriorityOptionClass = useCallback((priorityItem) => {
      const key = normaliseText(priorityItem?.id || priorityItem?.label || priorityItem);
      switch (key) {
        case "high":
          return "bug-select-option bug-priority-option-high";
        case "medium":
          return "bug-select-option bug-priority-option-medium";
        case "low":
          return "bug-select-option bug-priority-option-low";
        case "wishlist":
          return "bug-select-option bug-priority-option-wishlist";
        default:
          return "";
      }
    }, []);

    let currentPriorityIndex = getItemIndex(priorities, bugReport.priority);
    let currentStatusIndex = getItemIndex(statuses, bugReport.status);

    // if(developers && developers.length > 0 && bugReport.assignedTo) {
    //   for(var key in developers) {
    //     let developer = developers[key];
    //     if(developer.id == bugReport.assignedTo._id) {
    //       currentAssignedToIndex = parseInt(key);
    //     }
    //   }
    // }

    const [ priorityIndex, setPriorityIndex ] = useState(currentPriorityIndex);
    const [ statusIndex, setStatusIndex ] = useState(currentStatusIndex);
    //const [ assignedToIndex, setAssignedToIndex ] = useState(currentAssignedToIndex);
    const [ statusColourClass, setStatusColourClass ] = useState("");
    const [ priorityColourClass, setPriorityColourClass ] = useState("");
    const [ status, setStatus] = useState(bugReport.status);
    const [ priority, setPriority ] = useState(bugReport.priority);
    const [ assignedTo, setAssignedTo ] = useState(bugReport.assignedTo);

    let priorityCases = {};
    let stateCases = {};

    const changePriority = (e, id, item) => {
        e.preventDefault();
        if (changePriorityFunc) {
            changePriorityFunc(e, bugReport._id, item.id);
            setPriorityIndex(item.index);
        setPriorityColourClass(getPriorityClass(item));
        }
    }

    // const changeAssignedTo = (e, id, item) => {
    //   e.preventDefault();
    //   if(changeAssignedToFunc) {
    //     changeAssignedToFunc(e, bugReport._id, item.id);
    //     setAssignedToIndex(item.index);
    //   }
    // }

    const changeStatus = (e, id, item) => {
      e.preventDefault();
      if(changeStatusFunc) {
        changeStatusFunc(e, bugReport._id, item.id);
        setStatusIndex(item.index);
        setStatusColourClass(getStatusClass(item));
      }
    }

    const editBugReport = () => {
      prepareEditData({
        isEditing: true,
        priorityIndex: priorityIndex, 
        priorityColourClass: priorityColourClass, 
        statusIndex: statusIndex, 
        statusColourClass: statusColourClass, 
        //assignedToIndex: assignedToIndex,
      })
      setBugReportToEdit(bugReport);
    }

    useEffect(() => {
      const selectedPriority = priorities?.[priorityIndex] && !priorities?.[priorityIndex]?.deselect
        ? priorities[priorityIndex]
        : bugReport.priority;
      const selectedStatus = statuses?.[statusIndex] && !statuses?.[statusIndex]?.deselect
        ? statuses[statusIndex]
        : bugReport.status;
      setPriorityColourClass(getPriorityClass(selectedPriority));
      setStatusColourClass(getStatusClass(selectedStatus));
    }, [bugReport, priorities, statuses, priorityIndex, statusIndex, getPriorityClass, getStatusClass]);

    useEffect(() => {
      const nextPriorityIndex = getItemIndex(priorities, bugReport.priority);
      const nextStatusIndex = getItemIndex(statuses, bugReport.status);

      if (nextPriorityIndex !== priorityIndex) {
        setPriorityIndex(nextPriorityIndex);
      }

      if (nextStatusIndex !== statusIndex) {
        setStatusIndex(nextStatusIndex);
      }
    }, [bugReport, priorities, statuses, priorityIndex, statusIndex, getItemIndex]);

    const rowClass = "fl-row list-view-content list-view-content-list-item cursor-pointer";

    return (
        <div className={rowClass}>
            <div className="bugreports-data-block">
                <div className="title">{bugReport.title}</div>
            </div>
            <div className="bugreports-data-block">
                <div className="type">{bugReport.type}</div>
            </div>
            <div className="bugreports-data-block">
                <div className="bugReportCode">{bugReport.jiraIssueKey}</div>
            </div>
            <div className="bugreports-data-block bugreports-data-block--desc">
                <span className="description">{bugReport.description}</span>
            </div>
            <div className="bugreports-data-block">
                <DropDownList
                    id="priority"
                    items={priorities}
                    selectFunc={changePriority}
                    currentIndex={priorityIndex}
                    icon="priority"
                    className={priorityColourClass}
                  getItemClassName={getPriorityOptionClass}
                />
            </div>
            <div className="bugreports-data-block">
                {bugReport.reporter && <div className="reporter">{(bugReport.reporter.name === "TWITCH_LOCAL") ? `${bugReport.reporter.firstName} ${bugReport.reporter.lastName}` : bugReport.reporter.name}</div>}
                {!bugReport.reporter && <div className="reporter light-text">Unknown</div>}
            </div>
            <div className="bugreports-data-block">
                {bugReport.dateCreated && <div className="created">{getShortDateString(bugReport.dateCreated)}</div>}
            </div>
            <div className="bugreports-data-block">
                <DropDownList
                    id="status"
                    items={statuses}
                    selectFunc={changeStatus}
                    currentIndex={statusIndex}
                    icon="status"
                    className={statusColourClass}
                  getItemClassName={getStatusOptionClass}
                  menuAlign="right"
                  menuWidth="max-content"
                  menuMinWidth="100%"
                  menuMaxWidth="min(28rem, calc(100vw - 2rem))"
                  allowItemWrap={true}
                />
            </div>
            <div className="bugreports-data-block">
                <button className="standard-button" onClick={editBugReport}>Edit</button>
            </div>
        </div>
    );
}

export default ListedBugReport;
